export default function Logo() {
  return <h1 className='logo-title'>🏝️ Far Away 🧳</h1>;
}
